import { post } from "@libs:axios";
import { CamelCasedPropertiesDeep } from "type-fest";

import {
  AuthJwtLoginAuthJwtLoginPostResponse,
  BodyAuthJwtLoginAuthJwtLoginPost,
} from "@:openapi";

export const login = ({
  username,
  password,
}: CamelCasedPropertiesDeep<BodyAuthJwtLoginAuthJwtLoginPost>) => {
  const formData = new FormData();
  formData.set("username", username);
  formData.set("password", password);
  return post<CamelCasedPropertiesDeep<AuthJwtLoginAuthJwtLoginPostResponse>>(
    "/auth/jwt/login",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
};
